import * as actions from './constants';

const initialState = {
  orgLoading: true,
  orgDetails: [],
  selectedOrg: {}
};

// eslint-disable-next-line default-param-last
export default function orgReducer(state = initialState, action) {
  switch (action.type) {
    case actions.UPDATE_ORG:
      return {
        ...state,
        orgDetails: action.payload,
        selectedOrg: action.payload.length ? action.payload[0] : {},
        orgLoading: false
      };
    case actions.CHANGE_SELECTED_ORG:
      return {
        ...state,
        selectedOrg: action.payload
      };
    case actions.REMOVE_ORG:
      return {
        ...state,
        orgDetails: [],
        selectedOrg: {},
        orgLoading: true
      };
    default:
      return state;
  }
}
